import { Presentation } from 'lucide-react'

import { MobileNav } from './mobile-nav'
import { UserMenu } from './user-menu'

import type { ReactElement } from 'react'

import { ThemeToggle } from '@/components/shared/theme-toggle'
import { Button } from '@/components/ui/button'
import { useApresentacao } from '@/features/apresentacao/use-apresentacao'

export function Header(): ReactElement {
  const abrir = useApresentacao((s) => s.abrir)

  return (
    <header className="border-border bg-background/95 supports-[backdrop-filter]:bg-background/80 sticky top-0 z-30 flex h-14 items-center gap-2 border-b px-4 backdrop-blur sm:px-6">
      <MobileNav />
      <div className="ml-auto flex items-center gap-1">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={abrir}
          className="border-primary/50 bg-primary/10 text-primary hover:bg-primary/20 gap-2"
        >
          <Presentation className="h-4 w-4" aria-hidden />
          <span className="hidden sm:inline">Apresentar</span>
        </Button>
        <ThemeToggle />
        <UserMenu />
      </div>
    </header>
  )
}
